import React from 'react'
import { FaGithub, FaTwitter, FaLinkedinIn } from 'react-icons/fa'
import { Image } from 'react-bootstrap'
import logo from './logo.png'

const Footer = () => {
  return (
    <>
      <footer class='py-3 my-4'>
        <Image src={logo} height={40} width={40} />
        <p class='text-center text-muted'>© 2021 M.Bebars, Developer</p>
        <div className='border-bottom m-3'></div>
        <ul class='nav justify-content-center '>
          <a
            class='m-3'
            style={{ color: '#ffffff' }}
            href='https://github.com/mahmoud-bebars'
            height={50}
            width={50}
          >
            <h2>
              <FaGithub />
            </h2>
          </a>
          <a
            class='m-3'
            style={{ color: '#ffffff' }}
            href='https://github.com/mahmoud-bebars'
            height={50}
            width={50}
          >
            <h2>
              <FaTwitter />
            </h2>
          </a>
          <a
            class='m-3'
            style={{ color: '#ffffff' }}
            href='https://github.com/mahmoud-bebars'
            height={50}
            width={50}
          >
            <h2>
              <FaLinkedinIn />
            </h2>
          </a>
        </ul>
      </footer>
    </>
  )
}

export default Footer
